import { AHrefExternal, SPLink } from '../../components/SPLink'
import { Configuration } from '../../../kentico-types/configuration'
import { LOCALE, getTranslation } from '../../splus-lib/utils/languageUtils'
import { urls } from '../../urls'

import React from 'react'

type Props = {
  opened: boolean
  close: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  content?: Configuration
}

const MainMenu = (props: Props) => {
  return (
    <React.Fragment>
      <div
        className={props.opened ? 'saps-menu saps-menu--active' : 'saps-menu'}
        data-component='main-menu'
      >
        <div className='saps-menu-container container'>
          <SPLink href='#' className='saps-menu-close js-menu-close' onClick={props.close}>
            <svg
              width='40'
              height='40'
              viewBox='0 0 40 40'
              xmlns='http://www.w3.org/2000/svg'
              className='saps-menu-close__icon'
            >
              <path d='M5 5l29.8 29.8M34.8 5L5 34.8' className='saps-menu-close__path' />
            </svg>
          </SPLink>
          <div className='saps-menu-row'>
            <div className='saps-menu-col'>
              <p className='saps-menu-col__title'>
                {getTranslation('header.main.menu.title.skodaplus')}
              </p>
              <ul className='saps-menu-col__list'>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M16.14 8.6a.4.4 0 0 0-.36-.22H9.22a.4.4 0 0 0-.36.23l-.85 1.76 2.08.3.66-.37c.11-.06.24-.1.37-.1h2.76c.13 0 .26.04.37.1l.66.36 2.08-.3-.85-1.75zm1.57 3.27l-2.84.4a.78.78 0 0 1-.49-.09l-.7-.39H12.5h-1.19l-.7.39a.78.78 0 0 1-.49.09l-2.84-.4-.2.42 1.05.2c.2.05.37.21.41.42l.34 1.61a.53.53 0 0 1-.66.62l-1.4-.39.38 3.52h.63l.05-.53a.8.8 0 0 1-.3-.93.79.79 0 0 1 1.02-.47c.1.05.22.08.34.12.82.25 1.94.38 3.55.42a13.9 13.9 0 0 0 3.55-.42c.12-.04.24-.07.35-.12a.78.78 0 0 1 1.06.74.8.8 0 0 1-.35.66l.05.53h.63l.37-3.52-1.4.4a.52.52 0 0 1-.5-.12.52.52 0 0 1-.15-.5l.34-1.62c.04-.2.2-.37.41-.41l1.06-.2-.2-.43zM9.22 6.8h6.56c.75 0 1.44.44 1.77 1.12l2.11 4.36c.18.38.26.8.21 1.23l-.6 5.63c-.04.4-.38.71-.78.71h-2.05a.79.79 0 0 1-.78-.72l-.08-.93c-.82.15-1.8.23-3.06.26h-.04a19.53 19.53 0 0 1-3.06-.26l-.08.93a.79.79 0 0 1-.78.72H6.5c-.4 0-.74-.3-.79-.7l-.6-5.64c-.04-.42.04-.84.22-1.23l2.1-4.36A1.99 1.99 0 0 1 9.23 6.8zm12.25-.74c0-.18.06-.33.15-.45L12.5 2.63 3.38 5.6c.09.12.15.27.15.45v16.36h17.94V6.06zm2.99-1.2a.8.8 0 0 1 .5 1 .78.78 0 0 1-.99.51l-.93-.3V23.2c0 .44-.36.79-.79.79H2.75a.79.79 0 0 1-.79-.8V6.08l-.93.3a.79.79 0 0 1-.99-.51.8.8 0 0 1 .5-1l11.72-3.82a.78.78 0 0 1 .48 0l11.72 3.82zm-10.98 8.3l1.36-.13c.17-.01.33.05.45.18.1.13.15.3.11.46l-.27 1.2a.52.52 0 0 1-.2.3l-.63.46c-.09.07-.2.1-.3.1h-3a.52.52 0 0 1-.3-.1l-.62-.45a.52.52 0 0 1-.2-.31l-.28-1.2a.53.53 0 0 1 .11-.46c.12-.13.28-.2.45-.18l1.36.14c.06 0 .12.02.18.05l.52.25h.56l.52-.25a.52.52 0 0 1 .18-.05z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink
                    href={urls.root()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.homepage')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <g fill='none' fillRule='evenodd'>
                      <circle stroke='#FFF' strokeWidth='1.5' cx='12.5' cy='12.5' r='10.5' />
                      <path
                        /* eslint-disable-next-line max-len */
                        d='M12.5 6.54c.84 0 1.54.15 2.12.45a3.04 3.04 0 0 1 1.71 2.8c0 .9-.26 1.65-.8 2.27a4.86 4.86 0 0 1-2.29 1.38l-.01 1h-1.97v-2.28a8.4 8.4 0 0 0 1.46-.57c.37-.2.65-.43.84-.7a1.57 1.57 0 0 0 .13-1.6c-.1-.2-.27-.36-.5-.49-.22-.13-.49-.2-.81-.2-.46 0-.84.14-1.15.4-.31.27-.52.66-.63 1.16l-2.14-.3a3.8 3.8 0 0 1 1.33-2.48c.7-.56 1.6-.84 2.72-.84zM11.09 18v-2.35h2.36V18h-2.36z'
                        fill='#FFF'
                        fillRule='nonzero'
                      />
                    </g>
                  </svg>
                  <SPLink
                    href={urls.about()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.about')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M6.95 23.35C15.8 23.07 22.71 16 23.04 6.9l-3.5-.78-2.02 3.85 2.43 2.46c.23.23.28.58.13.87a15.33 15.33 0 0 1-7.54 7.24.75.75 0 0 1-.87-.18l-1.86-2.07-3.41 1.75.55 3.32zM23.97 5.56c.34.08.58.38.58.74-.05 10.42-8.01 18.56-18.14 18.56h-.1a.75.75 0 0 1-.73-.63l-.75-4.5a.75.75 0 0 1 .4-.79l4.41-2.26c.3-.15.67-.08.9.17l1.88 2.08c2.64-1.3 4.59-3.18 6.07-5.85l-2.43-2.45a.75.75 0 0 1-.13-.88l2.54-4.84c.16-.3.5-.46.83-.39l4.67 1.04zM2.5 2.5v7.14h7.13c.29 0 .55.16.68.41l.65 1.34.26-1.16a.75.75 0 0 1 .73-.6h1.67V2.5H2.5zm8.06 11.47l-1.4-2.83H1.76a.75.75 0 0 1-.75-.75V1.75c0-.41.34-.75.75-.75h12.62c.42 0 .75.34.75.75v8.64c0 .41-.33.75-.75.75h-1.81l-.59 2.66a.75.75 0 0 1-1.4.17zm-6.9-8.32a.75.75 0 0 1 0-1.5h3.93a.75.75 0 0 1 0 1.5H3.66zm9.55 1.6c0 .4-.34.74-.75.74h-8.8a.75.75 0 0 1 0-1.5h8.8c.41 0 .75.34.75.75z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink
                    href={urls.contact()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.contact')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M10.23 11V7h4v4h-4zm2-8.57a6.8 6.8 0 0 0-6.8 6.8c0 2.94 4.49 9.28 6.8 12.24 2.31-2.96 6.8-9.3 6.8-12.24 0-3.75-3.05-6.8-6.8-6.8zm0 21.31l-.55-.68C11.36 22.68 4 13.6 4 9.23a8.24 8.24 0 0 1 16.46 0c0 4.36-7.36 13.45-7.68 13.83l-.55.68z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink
                    href={urls.branches()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.branches')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 22 25'
                    className='saps-menu-col__list-item-icon'
                  >
                    <g
                      stroke='#FFF'
                      strokeWidth='1.5'
                      fill='none'
                      fillRule='evenodd'
                      strokeLinecap='round'
                    >
                      {/* eslint-disable-next-line max-len */}
                      <path d='M13.167 3.409a2.409 2.409 0 11-4.817 0 2.409 2.409 0 014.817 0zM13.443 7.477h-5.37c-.606 0-1.097.492-1.097 1.098v6.235c0 .606.49 1.097 1.097 1.097h.445v6.919c0 .57.461 1.031 1.03 1.031h2.467c.57 0 1.031-.462 1.031-1.031v-6.919h.397c.606 0 1.097-.491 1.097-1.097V8.575c0-.606-.491-1.098-1.097-1.098zM6.606 4.8a2.181 2.181 0 11-4.362 0 2.181 2.181 0 014.362 0z' />
                      {/* eslint-disable-next-line max-len */}{' '}
                      <path d='M6.875 8.53a1.31 1.31 0 00-.34-.045h-4.22C1.588 8.485 1 9.073 1 9.8v5.005c0 .726.589 1.315 1.314 1.315h.082v5.963c0 .682.553 1.235 1.235 1.235h1.632c.682 0 1.235-.553 1.235-1.235V16.12h.038c.267 0 .515-.08.722-.217M14.99 4.8a2.182 2.182 0 104.365 0 2.182 2.182 0 00-4.364 0zM14.723 8.53c.108-.03.221-.045.338-.045h4.223c.725 0 1.313.588 1.313 1.314v5.005c0 .726-.588 1.315-1.313 1.315H19.2v5.963c0 .682-.553 1.235-1.235 1.235h-1.631a1.234 1.234 0 01-1.235-1.235V16.12h-.039c-.266 0-.515-.08-.722-.217' />
                      {/* eslint-disable-next-line max-len */}{' '}
                      <path d='M13.443 7.477h-5.37c-.606 0-1.097.492-1.097 1.098v6.235c0 .606.49 1.097 1.097 1.097h.445v6.919c0 .57.461 1.031 1.03 1.031h2.467c.57 0 1.031-.462 1.031-1.031v-6.919h.397c.606 0 1.097-.491 1.097-1.097V8.575c0-.606-.491-1.098-1.097-1.098z' />
                    </g>
                  </svg>
                  {LOCALE === 'cs' && (
                    <AHrefExternal
                      href='https://www.skodamabudoucnost.cz'
                      className='saps-menu-col__list-item-a'
                      data-component='main-menu'
                    >
                      {getTranslation('header.main.menu.item.career')}
                    </AHrefExternal>
                  )}
                  {LOCALE === 'sk' && (
                    <AHrefExternal
                      href='https://www.skoda-mojabuducnost.sk'
                      className='saps-menu-col__list-item-a'
                      data-component='main-menu'
                    >
                      {getTranslation('header.main.menu.item.career')}
                    </AHrefExternal>
                  )}
                </li>
              </ul>
            </div>
            <div className='saps-menu-col'>
              <p className='saps-menu-col__title'>
                {getTranslation('header.main.menu.title.offer')}
              </p>
              <ul className='saps-menu-col__list'>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M19.14 22.67a4.2 4.2 0 1 0 0-8.39 4.2 4.2 0 0 0 0 8.39zm0-9.88a5.7 5.7 0 1 1-.01 11.4 5.7 5.7 0 0 1 .01-11.4zM5.6 3.02L4.2 5.9l3.52.5 1.02-.57c.11-.05.23-.09.36-.09h3.85c.12 0 .24.04.35.1l1.03.55 3.52-.5-1.4-2.88a.93.93 0 0 0-.83-.52h-9.2c-.34 0-.67.2-.82.52zM18 10.4l1.51-.44.02-.16c.02-.2-.01-.39-.08-.57l-1.27.23-.18.94zm-13.95 0l-.18-.94-1.27-.23c-.07.18-.1.38-.08.57l.01.16 1.52.44zm8.42 4.66a.75.75 0 0 1 0 1.5c-2.71 0-4.6-.13-6.08-.45l-.15 1.7a.75.75 0 0 1-.75.68H2.6a.75.75 0 0 1-.74-.67l-.84-7.86c-.06-.52.03-1.04.26-1.51l2.96-6.09A2.44 2.44 0 0 1 6.42 1h9.19c.92 0 1.77.53 2.17 1.36l2.97 6.09c.23.47.32 1 .26 1.52l-.22 2.1a.75.75 0 0 1-1.5-.16l.04-.33-2.1.6a.76.76 0 0 1-.71-.16.75.75 0 0 1-.24-.7l.51-2.65c.06-.3.3-.54.6-.6l1.39-.25-.25-.5-4.25.6a.75.75 0 0 1-.46-.08l-1.08-.59H9.28l-1.07.59c-.14.08-.3.1-.47.08l-4.24-.6-.25.5 1.38.26c.3.05.55.29.6.6l.51 2.64a.75.75 0 0 1-.95.86l-2.1-.6.59 5.4H4.8l.11-1.29H4.9a.75.75 0 0 1-.44-.97.75.75 0 0 1 .97-.44l.3.1h.06c.12.01.23.06.33.12 1.41.4 3.37.56 6.34.56zm1.59-4.16l.18-.78-1.22.12-.97.48c-.1.04-.21.07-.32.07H10.3a.74.74 0 0 1-.32-.07L9 10.24l-1.21-.12.18.78.67.48h4.73l.67-.48zm-1.32-2.14l2.4-.23a.75.75 0 0 1 .8.92l-.49 2.07a.75.75 0 0 1-.29.44l-1.1.78a.75.75 0 0 1-.43.14H8.4a.75.75 0 0 1-.44-.14l-1.1-.78a.75.75 0 0 1-.29-.44L6.1 9.44a.75.75 0 0 1 .8-.91l2.4.23c.08.01.17.04.24.07l.95.46h1.04l.95-.46a.74.74 0 0 1 .25-.07zm6.95 7.9v1.37h1.38v.96h-1.38v1.38h-1.04V19h-1.42v-.96h1.42v-1.37h1.04z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink
                    href={urls.buyingVehicle()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.buying')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      fill='#FFF'
                      fillRule='evenodd'
                      /* eslint-disable-next-line max-len */
                      d='M19.1 22.7a4.2 4.2 0 0 0 4.2-4.2 4.2 4.2 0 0 0-4.2-4.2 4.2 4.2 0 0 0-4.1 4.2 4.2 4.2 0 0 0 4.1 4.2zm0-10a5.7 5.7 0 0 1 5.7 5.8 5.7 5.7 0 0 1-5.7 5.7 5.7 5.7 0 0 1-5.6-5.7 5.7 5.7 0 0 1 5.6-5.7zM5.6 3L4.2 6l3.5.4 1-.6a.7.7 0 0 1 .4 0h4.2l1 .6 3.5-.5L16.4 3a1 1 0 0 0-.8-.5H6.4a1 1 0 0 0-.8.5zM18 10.4l1.5-.4v-.2a1.3 1.3 0 0 0 0-.6l-1.3.3-.2.9zm-14 0l-.1-1-1.3-.2a1.3 1.3 0 0 0 0 .6v.2l1.4.4zm8.5 4.7a.8.8 0 0 1 0 1.5c-2.8 0-4.6-.2-6.1-.5l-.2 1.7a.8.8 0 0 1-.7.7H2.6a.8.8 0 0 1-.7-.7L1 10a2.8 2.8 0 0 1 .3-1.6l3-6A2.4 2.4 0 0 1 6.3 1h9.2c1 0 1.8.5 2.2 1.4l3 6c.2.5.3 1 .2 1.6l-.2 2a.8.8 0 0 1-1.5-.1v-.3l-2 .6a.8.8 0 0 1-.8-.2.7.7 0 0 1-.2-.7l.5-2.6a.7.7 0 0 1 .6-.6l1.4-.3-.3-.5-4.2.6a.7.7 0 0 1-.5 0l-1-.6H9.2l-1 .5a.7.7 0 0 1-.6.1l-4.2-.6-.2.5 1.3.3a.7.7 0 0 1 .6.6l.5 2.6a.7.7 0 0 1-.7 1 .8.8 0 0 1-.2-.1l-2.1-.6.6 5.4h1.5l.1-1.3a.8.8 0 0 1-.4-1 .8.8 0 0 1 1-.4h.2a.7.7 0 0 1 .4.2c1.4.4 3.4.6 6.4.6zm1.5-4.2l.2-.8-1.2.1-1 .5a.7.7 0 0 1-.3 0l-.7.1h-.7a.7.7 0 0 1-.3 0l-1-.6H7.8l.2.7.6.5h4.8l.6-.5zm-1.3-2.1l2.4-.3a.8.8 0 0 1 .8 1l-.5 2a.7.7 0 0 1-.2.5l-1.1.7a.7.7 0 0 1-.5.2H8.4a.7.7 0 0 1-.4-.2L6.9 12a.8.8 0 0 1-.3-.5l-.5-2a.8.8 0 0 1 .8-1l2.4.3a.7.7 0 0 1 .2 0l1 .5h1l1-.5a.7.7 0 0 1 .2 0zM18 19v-1h2.4v1H18z'
                    />
                  </svg>
                  <SPLink
                    href={urls.sellingVehicle()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.selling')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <g fill='#FFF' fillRule='evenodd'>
                      {/* eslint-disable-next-line max-len */}
                      <path d='M23.25 15.14l-.59.18a2.65 2.65 0 0 0-2.54-1.96c-1.3 0-2.39.95-2.6 2.2H8.33a2.65 2.65 0 0 0-2.6-2.2c-1.14 0-2.1.72-2.48 1.73l-.7-.4.35-2.87 3.15-3.07 5.64-.25s.93 0 1.95.24c.64.15 2.42 1.53 3.47 2.47.12.1.26.16.41.18.02 0 .47.06 2.98.53a3.7 3.7 0 0 1 2.75 1.99v1.23zm-3.13 2.01a1.15 1.15 0 1 1 0-2.3 1.15 1.15 0 0 1 0 2.3zm-14.4 0a1.15 1.15 0 0 1 0-2.3 1.15 1.15 0 0 1 0 2.3zm18.99-3.64c-.04-.1-.91-2.5-3.94-3.06-1.72-.33-2.5-.46-2.83-.51-.72-.63-2.83-2.4-3.96-2.66C12.78 7 11.75 7 11.66 7l-5.97.26a.75.75 0 0 0-.49.21l-3.54 3.46a.75.75 0 0 0-.22.45L1 15c-.04.3.1.59.37.73L3.2 16.8a2.64 2.64 0 0 0 4.95.26h9.53a2.64 2.64 0 0 0 4.9-.15l1.63-.5c.32-.1.53-.39.53-.72v-1.93a.76.76 0 0 0-.04-.25z' />
                      <path
                        /* eslint-disable-next-line max-len */
                        d='M9.91 10.48h.5V14h-.76v-2.63l-.88.46-.07-.69 1.21-.66zm2.96 2.3h-.48V14h-.76v-3.52h1.48c.24 0 .45.05.64.15.18.1.33.23.43.4a1.15 1.15 0 0 1-.03 1.2c-.12.18-.3.31-.5.4L14.6 14h-.9l-.82-1.22zm-.48-.66h.63c.1 0 .19-.02.27-.06a.47.47 0 0 0 .25-.44c0-.1-.02-.18-.07-.25a.44.44 0 0 0-.19-.16.62.62 0 0 0-.26-.06h-.63v.97z'
                        fillRule='nonzero'
                      />
                    </g>
                  </svg>
                  <SPLink
                    href={urls.yearOldCars()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.yearly')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <g fill='none' fillRule='evenodd'>
                      <path
                        /* eslint-disable-next-line max-len */
                        d='M23.25 15.14l-.59.18a2.65 2.65 0 0 0-2.54-1.96c-1.3 0-2.39.95-2.6 2.2H8.33a2.65 2.65 0 0 0-2.6-2.2c-1.14 0-2.1.72-2.48 1.73l-.7-.4.35-2.87 3.15-3.07 5.64-.25s.93 0 1.95.24c.64.15 2.42 1.53 3.47 2.47.12.1.26.16.41.18.02 0 .47.06 2.98.53a3.7 3.7 0 0 1 2.75 1.99v1.23zm-3.13 2.01a1.15 1.15 0 1 1 0-2.3 1.15 1.15 0 0 1 0 2.3zm-14.4 0a1.15 1.15 0 0 1 0-2.3 1.15 1.15 0 0 1 0 2.3zm18.99-3.64c-.04-.1-.91-2.5-3.94-3.06-1.72-.33-2.5-.46-2.83-.51-.72-.63-2.83-2.4-3.96-2.66C12.78 7 11.75 7 11.66 7l-5.97.26a.75.75 0 0 0-.49.21l-3.54 3.46a.75.75 0 0 0-.22.45L1 15c-.04.3.1.59.37.73L3.2 16.8a2.64 2.64 0 0 0 4.95.26h9.53a2.64 2.64 0 0 0 4.9-.15l1.63-.5c.32-.1.53-.39.53-.72v-1.93a.76.76 0 0 0-.04-.25z'
                        fill='#FFF'
                      />
                      <path
                        stroke='#FFF'
                        d='M11.5 13.2l-1.18.62.23-1.31-.95-.93 1.31-.19.59-1.19.59 1.19 1.31.19-.95.93.23 1.31z'
                      />
                    </g>
                  </svg>
                  <SPLink
                    href={urls.triedCars()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.tried')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M23.25 14.64V13.4a3.7 3.7 0 0 0-2.76-2c-2.5-.46-2.95-.52-2.97-.52a.78.78 0 0 1-.41-.19c-1.05-.93-2.83-2.31-3.47-2.46A9.92 9.92 0 0 0 11.69 8l-5.64.24-3.15 3.07-.35 2.88.7.4a2.65 2.65 0 0 1 5.08.47h9.19a2.65 2.65 0 0 1 2.6-2.2c1.22 0 2.24.83 2.54 1.96l.6-.18zm-3.13 2.01a1.15 1.15 0 1 0 0-2.3 1.15 1.15 0 0 0 0 2.3zm-14.4 0a1.15 1.15 0 0 0 0-2.3 1.15 1.15 0 0 0 0 2.3zm18.99-3.64c.03.08.04.16.04.25v1.93c0 .33-.21.62-.53.72l-1.62.5a2.65 2.65 0 0 1-4.91.15H8.16c-.41.93-1.35 1.6-2.43 1.6a2.64 2.64 0 0 1-2.51-1.86l-1.84-1.06a.75.75 0 0 1-.37-.73l.43-3.64c.02-.17.1-.32.22-.44L5.2 6.97c.14-.13.31-.2.5-.21l5.96-.26c.08 0 1.12 0 2.31.28 1.14.26 3.25 2.03 3.97 2.66.34.05 1.11.18 2.83.5a5.13 5.13 0 0 1 3.94 3.07zm-4.57 7.4l-.79-.78 3.27-.63-.63 3.27-.8-.8a11.93 11.93 0 0 1-8.37 3.41 11.9 11.9 0 0 1-8.7-3.73.75.75 0 0 1 .03-1.06.75.75 0 0 1 1.06.03c2 2.1 4.7 3.26 7.61 3.26 2.75 0 5.35-1.05 7.32-2.97zM5.5 4.47l.79.78-3.27.63.63-3.26.8.79C6.7 1.2 9.67 0 12.82 0a11.9 11.9 0 0 1 8.7 3.73.75.75 0 1 1-1.09 1.04c-2-2.11-4.7-3.27-7.61-3.27-2.75 0-5.34 1.06-7.32 2.97z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink
                    href={urls.usedCars()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.used')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M6.54 2.53a4.99 4.99 0 0 0-3.8 8.29l9.76 11.4 9.76-11.4a4.99 4.99 0 0 0-.54-7.08 4.99 4.99 0 0 0-7.08.55l-1.56 1.82a.8.8 0 0 1-1.16 0l-1.56-1.82a4.99 4.99 0 0 0-3.82-1.76zm5.96 21.64a.77.77 0 0 1-.58-.27L1.57 11.82a6.56 6.56 0 0 1 9.96-8.53l.97 1.14.97-1.14a6.5 6.5 0 0 1 4.47-2.27 6.56 6.56 0 0 1 5.48 10.8L13.09 23.9a.77.77 0 0 1-.58.27zM21.52 9a.77.77 0 0 1-.76-.76c0-.97-.43-1.87-1.19-2.48a.77.77 0 0 1 .96-1.2 4.7 4.7 0 0 1 1.76 3.68c0 .42-.34.76-.77.76z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink
                    href={urls.alternativeDrives()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.alternative')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M8.22 3.52c-1 .2-1.57 1.67-1.26 3.2.3 1.53 1.41 2.65 2.4 2.45.6-.12.94-.67 1.08-.99a3.7 3.7 0 0 0 .2-2.2A3.7 3.7 0 0 0 9.6 4c-.22-.2-.64-.5-1.14-.5l-.24.01zm.9 7.18c-1.66 0-3.2-1.51-3.63-3.68-.5-2.4.58-4.59 2.43-4.97.92-.18 1.9.13 2.7.86a5.16 5.16 0 0 1 1.48 2.77c.23 1.1.12 2.21-.3 3.12a3.08 3.08 0 0 1-2.13 1.84c-.18.04-.37.06-.55.06zm-3.8 2.9c.06-.42-.06-.9-.32-1.31-.37-.59-.96-.94-1.48-.94a.98.98 0 0 0-.53.15c-.59.36-.66 1.35-.16 2.15.5.8 1.43 1.16 2.01.8.27-.17.44-.47.49-.84zm1.5.2c-.1.8-.53 1.51-1.18 1.91-.4.26-.85.38-1.32.38-1.03 0-2.1-.6-2.76-1.64-.95-1.51-.67-3.4.63-4.22 1.3-.82 3.13-.25 4.08 1.26.45.71.64 1.53.54 2.3zm11.2 7.56c.26-.51.35-1.25-.15-1.82-.19-.21-.42-.4-.68-.63-.5-.4-1.1-.91-1.73-1.8-.46-.65-.63-1.36-.77-1.92a3.4 3.4 0 0 0-.23-.75 2.14 2.14 0 0 0-1.97-1.18c-1.37 0-1.75.68-2.03 1.18a3.5 3.5 0 0 0-.23.75c-.14.56-.3 1.27-.77 1.92-.63.89-1.24 1.4-1.72 1.8-.27.22-.5.42-.69.63-.5.57-.4 1.31-.15 1.82.29.56.94 1.14 1.84 1.05.35-.03.84-.12 1.36-.2.86-.16 1.74-.36 2.36-.3.64-.05 1.5.14 2.36.3.52.08 1 .17 1.36.2.94.09 1.55-.49 1.84-1.05zm.13-3.6c.3.25.58.49.84.78.83.94.97 2.3.37 3.5a3.36 3.36 0 0 1-3.32 1.86c-.38-.03-.91-.12-1.47-.22a14.91 14.91 0 0 0-2.18-.27c-.47 0-1.3.14-2.03.27a20.3 20.3 0 0 1-1.79.24 3.38 3.38 0 0 1-3-1.88 3.11 3.11 0 0 1 .36-3.5c.26-.3.55-.53.84-.78.47-.39.95-.79 1.47-1.52.3-.41.42-.92.53-1.4.1-.4.2-.79.38-1.13a3.46 3.46 0 0 1 3.34-1.95c1.4 0 2.57.7 3.28 1.95.19.34.28.72.38 1.13.11.48.24.99.53 1.4.52.73 1 1.13 1.47 1.52zM14.58 5.98c-.3 1.53.27 2.99 1.27 3.2.6.12 1.12-.26 1.37-.5a3.7 3.7 0 0 0 1.04-1.96c.16-.78.09-1.59-.2-2.2-.14-.32-.47-.87-1.07-1-1-.2-2.1.93-2.4 2.46zm.97 4.66c-1.86-.37-2.93-2.56-2.44-4.96.5-2.41 2.33-4 4.18-3.62.92.18 1.7.85 2.14 1.83.42.92.52 2.03.3 3.13a5.15 5.15 0 0 1-1.5 2.77c-.64.6-1.39.9-2.14.9-.18 0-.36-.01-.54-.05zm6.71 3.01c.26-.41.38-.89.33-1.32a1.12 1.12 0 0 0-.49-.83.99.99 0 0 0-.53-.15c-.13 0-.28.03-.43.08-.4.13-.79.45-1.05.86s-.37.9-.32 1.32c.05.37.22.67.48.83.27.17.61.2.97.08.4-.14.78-.46 1.04-.87zm1.81-1.5c.1.77-.1 1.59-.54 2.3-.44.7-1.1 1.24-1.83 1.49-.3.1-.61.15-.92.15a2.5 2.5 0 0 1-1.33-.38 2.62 2.62 0 0 1-1.17-1.92c-.1-.77.1-1.59.54-2.3.45-.7 1.1-1.24 1.84-1.49.78-.26 1.6-.18 2.24.23.66.4 1.07 1.09 1.17 1.92z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink
                    href={urls.pageWatchdog()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.watchdog')}
                  </SPLink>
                </li>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M23.25 15.14l-.59.18a2.65 2.65 0 0 0-2.54-1.96c-1.3 0-2.39.95-2.6 2.2H8.33a2.65 2.65 0 0 0-2.6-2.2c-1.14 0-2.1.72-2.48 1.73l-.7-.4.35-2.87 3.15-3.07 5.64-.25s.93 0 1.95.24c.64.15 2.42 1.53 3.47 2.47.12.1.26.16.41.18.02 0 .47.06 2.98.53a3.7 3.7 0 0 1 2.75 1.99v1.23zm-3.13 2.01a1.15 1.15 0 1 1 0-2.3 1.15 1.15 0 0 1 0 2.3zm-14.4 0a1.15 1.15 0 0 1 0-2.3 1.15 1.15 0 0 1 0 2.3zm18.99-3.64c-.04-.1-.91-2.5-3.94-3.06-1.72-.33-2.5-.46-2.83-.51-.72-.63-2.83-2.4-3.96-2.66C12.78 7 11.75 7 11.66 7l-5.97.26a.75.75 0 0 0-.49.21l-3.54 3.46a.75.75 0 0 0-.22.45L1 15c-.04.3.1.59.37.73L3.2 16.8a2.64 2.64 0 0 0 4.95.26h9.53a2.64 2.64 0 0 0 4.9-.15l1.63-.5c.32-.1.53-.39.53-.72v-1.93a.76.76 0 0 0-.04-.25z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink href={urls.overviewModels()} className='saps-menu-col__list-item-a '>
                    {getTranslation('header.main.menu.item.models')}
                  </SPLink>
                </li>
              </ul>
            </div>
            <div className='saps-menu-col'>
              <p className='saps-menu-col__title'>
                {getTranslation('header.main.menu.title.products')}
              </p>
              <ul className='saps-menu-col__list'>
                <li className='saps-menu-col__list-item'>
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    xmlns='http://www.w3.org/2000/svg'
                    className='saps-menu-col__list-item-icon'
                  >
                    <path
                      /* eslint-disable-next-line max-len */
                      d='M3.5 3.6a1.1 1.1 0 1 0 2.19 0 1.1 1.1 0 0 0-2.19 0zm3.69 0a2.6 2.6 0 1 1-5.2-.01 2.6 2.6 0 0 1 5.2 0zM7.1 9.8a1.1 1.1 0 1 0-2.19 0 1.1 1.1 0 0 0 2.2 0zm-3.69 0a2.6 2.6 0 1 1 5.2 0 2.6 2.6 0 0 1-5.2 0zm7.54-5a.63.63 0 1 0 0 1.27.63.63 0 0 0 0-1.27zm0 2.77a2.13 2.13 0 1 1 0-4.27 2.13 2.13 0 0 1 0 4.27zM4.5 23.41h17.4v-8.17H4.5v8.17zm15.26-11.27l-8.27 1.6h8.6l-.33-1.6zm1.85 1.6h1.78V24.9H3V13.74h.6l17.34-3.36.68 3.36zm-4.5 9.24a.75.75 0 0 1-.75-.75v-5.81a.75.75 0 0 1 1.5 0v5.81c0 .41-.34.75-.75.75z'
                      fill='#FFF'
                      fillRule='evenodd'
                    />
                  </svg>
                  <SPLink
                    href={urls.financing()}
                    className='saps-menu-col__list-item-a'
                    data-component='main-menu'
                  >
                    {getTranslation('header.main.menu.item.financing')}
                  </SPLink>
                </li>
                {LOCALE === 'cs' && (
                  <li className='saps-menu-col__list-item'>
                    <svg
                      width='25'
                      height='25'
                      viewBox='0 0 25 25'
                      xmlns='http://www.w3.org/2000/svg'
                      className='saps-menu-col__list-item-icon'
                    >
                      <path
                        /* eslint-disable-next-line max-len */
                        d='M13.74 13.34l.98 7.38a.75.75 0 0 1-1.49.2l-1.11-8.4 4.4-2.39a.75.75 0 0 1 .71 1.32l-3.49 1.9zm-.81 10.02a10.44 10.44 0 0 0 0-20.86 10.44 10.44 0 0 0 0 20.86zm11.93-10.43c0 6.58-5.35 11.93-11.93 11.93A11.94 11.94 0 0 1 1 12.93C1 6.35 6.35 1 12.93 1s11.93 5.35 11.93 11.93z'
                        fill='#FFF'
                        fillRule='evenodd'
                      />
                    </svg>
                    <SPLink
                      href={urls.extendedWarranty()}
                      className='saps-menu-col__list-item-a'
                      data-component='main-menu'
                    >
                      {getTranslation('header.main.menu.item.warranty')}
                    </SPLink>
                  </li>
                )}
                {LOCALE === 'cs' && (
                  <li className='saps-menu-col__list-item'>
                    <svg
                      width='25'
                      height='25'
                      viewBox='0 0 25 25'
                      xmlns='http://www.w3.org/2000/svg'
                      className='saps-menu-col__list-item-icon'
                    >
                      <path
                        /* eslint-disable-next-line max-len */
                        d='M22.83 17.3c0 .08-.07.14-.16.14h-1.8a.15.15 0 0 1-.16-.15v-4.86c0-.08.07-.15.16-.15h1.8c.09 0 .16.07.16.15v4.86zm-11.98.78a76.74 76.74 0 0 1-4.92-1.63 46.4 46.4 0 0 1-3.63-1.73l.02-.11c.73.12 3.69.94 6.32 1.72.13.03.27.04.4 0l3.91-1.02a.75.75 0 0 0-.14-1.48 55.37 55.37 0 0 1-5.01-.5.96.96 0 0 1-.33-.25l.01-.04c.3-.17 1.93-.41 6.23-.27h.22c2.78.09 3.53.24 3.73.32l1.55.63v2.24l-8.36 2.12zM3.8 12.8a.71.71 0 1 1 0-1.42.71.71 0 0 1 0 1.42zm2.2.53c.05.3.2.56.38.77l-1.17-.32c.23-.2.42-.43.56-.7h.2c0 .08 0 .16.02.25zM1.8 8.96l2.33-2.27 4.26-.19c.01 0 .7 0 1.47.18.4.1 1.67 1.04 2.6 1.86.1.1.25.16.4.18.02 0 .37.05 2.28.4a2.7 2.7 0 0 1 1.98 1.4v.95l-.16-.02c0-.07-.02-.15-.04-.22a2.2 2.2 0 0 0-4.07.02c-3.55-.09-5.07.11-5.76.34H5.95a2.2 2.2 0 1 0-4.13-.43L1.55 11l.25-2.04zm20.87 1.82h-1.8c-.8 0-1.48.58-1.62 1.33l-.63-.25v-1.49a.75.75 0 0 0-.04-.25 4.13 4.13 0 0 0-3.16-2.47 99.3 99.3 0 0 0-2.14-.38c-.66-.57-2.2-1.85-3.09-2.05C9.26 5 8.44 5 8.36 5l-4.58.2a.75.75 0 0 0-.5.21L.57 8.07a.75.75 0 0 0-.22.45L0 11.32c-.04.3.1.58.37.73l1.35.78.14.32c-.22.06-.42.17-.59.33-.55.57-.51 1.55-.5 1.74.02.25.17.48.4.6.1.06 2.47 1.33 4.2 2.02 1.72.69 5.1 1.7 5.24 1.73a.74.74 0 0 0 .4.01l8.21-2.08c.11.81.8 1.45 1.64 1.45h1.8c.92 0 1.66-.75 1.66-1.66v-4.86c0-.9-.74-1.65-1.66-1.65z'
                        fill='#FFF'
                        fillRule='evenodd'
                      />
                    </svg>
                    <SPLink
                      href={urls.insurance()}
                      className='saps-menu-col__list-item-a'
                      data-component='main-menu'
                    >
                      {getTranslation('header.main.menu.item.insurance')}
                    </SPLink>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className='saps-menu-bottom'>
            <ul className='saps-menu-bottom__list'>
              <li className='saps-menu-bottom__list-item'>
                <SPLink href={urls.faq()} className='saps-menu-bottom__list-item-a'>
                  {getTranslation('header.main.menu.item.faq')}
                </SPLink>
              </li>
              <li className='saps-menu-bottom__list-item'>
                <SPLink
                  href={urls.processingOfPersonalData()}
                  className='saps-menu-bottom__list-item-a'
                >
                  {getTranslation('header.main.menu.item.gdpr')}
                </SPLink>
              </li>
              <li className='saps-menu-bottom__list-item'>
                <SPLink
                  href={
                    props.content?.odkazNaNastaveniCookies.value ??
                    'https://www.skoda-auto.com/system/cookies-settings'
                  }
                  className='saps-menu-bottom__list-item-a'
                >
                  {getTranslation('header.main.menu.item.cookies')}
                </SPLink>
              </li>
              <li className='saps-menu-bottom__list-item'>
                <SPLink href={urls.copyright()} className='saps-menu-bottom__list-item-a'>
                  {getTranslation('header.main.menu.item.copyright')}
                </SPLink>
              </li>
              <li className='saps-menu-bottom__list-item'>
                <SPLink href={urls.sitemap()} className='saps-menu-bottom__list-item-a'>
                  {getTranslation('header.main.menu.item.sitemap')}
                </SPLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
export default MainMenu
